import { render } from "./modal-edit-pertanyaan.vue?vue&type=template&id=57be4e86&scoped=true"
import script from "./modal-edit-pertanyaan.vue?vue&type=script&lang=js"
export * from "./modal-edit-pertanyaan.vue?vue&type=script&lang=js"

import "./modal-edit-pertanyaan.vue?vue&type=style&index=0&id=57be4e86&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57be4e86"]])

export default __exports__